import React from "react";
import { useLocation } from "react-router-dom";
import ProductCard from "../components/ProductCard";

function SearchResults() {
  const { state } = useLocation();
  const results = state?.results || [];
  const query = state?.query || "";

  return (
    <div className="container mt-4">
      <h3>
        Search Results for <span className="text-primary">"{query}"</span>
      </h3>
      {results.length === 0 ? (
        <p>No products found.</p>
      ) : (
        <div className="row">
          {results.map((product) => (
            <div className="col-md-4" key={product.id}>
              <ProductCard product={product} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default SearchResults;
